import { render } from "./successLogout.vue?vue&type=template&id=78f2ecc8"
import script from "./successLogout.vue?vue&type=script&lang=js"
export * from "./successLogout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__